import React, { useEffect, useState } from 'react'
import Media from './userProfile/Media'
import Actions from './userProfile/Actions'
import BlogList from './userProfile/BlogList'
import { useSearchParams } from 'react-router-dom'
import { host } from './script/variables'

/* ── Tab definitions ── */
const TABS = [
  {
    id: 0,
    label: 'Media',
    icon: (
      <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="2" width="7" height="7" rx="2" stroke="currentColor" strokeWidth="1.6"/>
        <rect x="11" y="2" width="7" height="7" rx="2" stroke="currentColor" strokeWidth="1.6"/>
        <rect x="2" y="11" width="7" height="7" rx="2" stroke="currentColor" strokeWidth="1.6"/>
        <rect x="11" y="11" width="7" height="7" rx="2" stroke="currentColor" strokeWidth="1.6"/>
      </svg>
    ),
  },
  // {
  //   id: 1,
  //   label: 'Activity',
  //   icon: (
  //     <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  //       <path d="M2 10h3l2-6 4 12 2-6h5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
  //     </svg>
  //   ),
  // },
  {
    id: 2,
    label: 'Blogs',
    icon: (
      <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 4h12v2H4zM4 9h8v2H4zM4 14h10v2H4z" fill="currentColor" opacity=".7"/>
      </svg>
    ),
  },
]

const UserProfile = () => {
  const [params] = useSearchParams()
  const [activeTab, setActiveTab] = useState(0)
  const [user, setUser] = useState(null)
  const email = params.get('id')

  const userData = async () => {
    try {
      const response = await fetch(`${host}/masala/user?id=${email}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      })
      if (response.ok) {
        const data = await response.json()

        setUser(data)
      }
    } catch (error) {
      console.error('Error fetching user data:', error)
    }
  }

  useEffect(() => {
    userData()
  }, [email])

  return (
    <div className="up-page">

      {/* ── Hero ── */}
      <div className="up-hero">
        <div className="up-hero-grain" />
        <div className="up-hero-content">

          {/* Avatar */}
          <div className="up-avatar-wrap">
            {user?.image
              ? <img className="up-avatar" src={user.image} alt={user.displayName} />
              : <div className="up-avatar" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 32 }}>🧑</div>
            }
            <div className="up-avatar-ring" />
          </div>

          {/* Name + username + socials */}
          <div className="up-hero-text">
            {user ? (
              <>
                <h1 className="up-display-name">{user.displayName}</h1>
                <p className="up-username">@{user.username}</p>

                <div className="up-socials">
                  {user.insta && (
                    <a className="up-social-btn" href={`https://instagram.com/${user.insta}`} target="_blank" rel="noreferrer" title="Instagram">
                      <svg viewBox="0 0 448 512"><path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"/></svg>
                    </a>
                  )}
                  {user.linkedin  && (
                    <a className="up-social-btn" href={user.linkedin} target="_blank" rel="noreferrer" title="LinkedIn">
                      <svg viewBox="0 0 448 512"><path d="M100.3 448H7.4V148.9h92.9zM53.8 108.1C24.1 108.1 0 83.5 0 53.8a53.8 53.8 0 0 1 107.6 0c0 29.7-24.1 54.3-53.8 54.3zM447.9 448h-92.7V302.4c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7V448h-92.8V148.9h89.1v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3V448z"/></svg>
                    </a>
                  )}
                  {user.twitter && (
                    <a className="up-social-btn" href={user.twitter} target="_blank" rel="noreferrer" title="X / Twitter">
                      <svg viewBox="0 0 512 512"><path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"/></svg>
                    </a>
                  )}
                </div>
              </>
            ) : (
              /* skeleton */
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                <div style={{ width: 180, height: 26, borderRadius: 6, background: 'rgba(255,255,255,0.08)' }} />
                <div style={{ width: 100, height: 14, borderRadius: 4, background: 'rgba(255,255,255,0.05)' }} />
              </div>
            )}
          </div>
        </div>
      </div>

      {/* ── Tab bar ── */}
      <div className="up-tabs">
        {TABS.map(tab => (
          <button
            key={tab.id}
            className={`up-tab${activeTab === tab.id ? ' active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.icon}
            {tab.label}
          </button>
        ))}
      </div>

      {/* ── Tab content ── */}
      <div className="up-panel" key={activeTab}>
        {activeTab === 0 && <Media id={email} />}
        {/* {activeTab === 1 && <Actions id={email} isMyProfile={false} />} */}
        {activeTab === 2 && <BlogList id={email} />}
      </div>

    </div>
  )
}

export default UserProfile